// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GRvw","content":"styles_content__1caiX","row":"styles_row__3CjiQ","footer":"styles_footer__2pFZw","phraseLength":"styles_phraseLength__q0jBI"};